import { CapoPlugin } from "/opt/buildhome/repo/node_modules/.pnpm/@unhead+vue@1.11.10_vue@3.5.12/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];